module.exports = __webpack_public_path__ + "static/media/umberella.0b0854a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/umberella.svg
// module id = 3004
// module chunks = 0